import { isObject } from '../../../utils'
import EntityBadge, { EntityCategories, getEntityCategory } from './EntityBadge'

const SchoolNameWithBadge = ({ school, size = 'sm', renderTooltip = false, renderAbbreviation = false, badgePosition = 'right' }) => {
  if (!isObject(school)) {
    return null
  }

  const name = renderAbbreviation ? school.abbreviation : school.name

  if (getEntityCategory(school) === EntityCategories.OTHERS) {
    return name
  }

  const badge = <EntityBadge entity={school} size={size} withTooltip={renderTooltip} />

  return (
    <span>
      {badgePosition === 'left' ? badge : null} {name} {badgePosition === 'right' ? badge : null}
    </span>
  )
}

export default SchoolNameWithBadge
